import React, { useState , useEffect} from "react";
import { accountStatementDownload } from "../../api";
import Filter from "../../Common/Filter";
import { Spinner } from "react-bootstrap";
import styles from "./AccountDetail.module.css";

const AccountStatement = ({ userId, accountType = "GLOBAL_LIEN", isActive }) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currency, setCurrency] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const formatDate = (date) => {
    if (!date) return "";

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  };
  const resetFilters = () => {
  setStartDate("");
  setEndDate("");
  setCurrency("");
  setErrorMessage("");
  };
  useEffect(() => {
  resetFilters();
  }, [isActive]);

  const handleDownload = async () => {
    if (!startDate || !endDate) {
      setErrorMessage("Please select dates");
      return;
    }
    if (endDate < startDate) {
    setErrorMessage("End date cannot be before start date");
      return;
    }
     if (!currency) {
      setErrorMessage("Please select currency");
      return;
    }

    setLoading(true);
    setErrorMessage("");

    try {
      const resp = await accountStatementDownload(
        userId,
        accountType,
        formatDate(startDate),
        formatDate(endDate),
        currency
      );

      if (resp?.status === 200 && resp?.data) {
        const blob = new Blob([resp.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `${accountType}_Statement_${formatDate(startDate)}_${formatDate(endDate)}.pdf`;
        link.click();

        window.URL.revokeObjectURL(url);
        setSuccessMessage("Account Statement downloaded successfully");
        resetFilters();
        setTimeout(() => {
        setSuccessMessage("");
      }, 3000);
      } else {
        setErrorMessage("Failed to download statement");
      }
    } catch (err) {
      setErrorMessage("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{  background: "var(--theme-colorbg)", height: "120px", padding: "20px", borderRadius: "8px" }}>
      <Filter
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        transactionCurrency={currency}
        setTransactionCurrency={setCurrency}
        showTransactionCurrency={true}
        onSearch={handleDownload}
        loading={loading}
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
        showPartner={false}
        showStatus={false}
        showCouponStatus={false}
        showNextStep={false}
        showAccountStatus={false}
        showAppName={false}
        showFetchBy={false}
        showMcbStatus={false}
        showTransactionStatus={false}
        buttonTitle="Download"
      />

      {successMessage && (
      <div style={{ color: "green", marginTop: "12px", textAlign: "center" }}>
        {successMessage}
      </div>
    )}
    </div>
  );
};

export default AccountStatement;
